export default {
  FETCH_DATA: 'bkcont_completed_fetch_data',
  UPDATE_QUERY: 'bkcont_completed_update_query',
  LOAD_MORE_DATA: 'bkcont_completed_load_more_data',
  UPDATE_LOADING: 'bkcont_completed_update_loading',
  UPDATE_SELECTED: 'bkcont_completed_update_selected',
};
